/*
* TODO
* The information such as box_count and mp_count should be accessible from parent.
* withCarrier hoc is created with the idea that we will have only box to share with, we should remove the usage here
* items used from withCarrier should be carried to a hook called useBoxCarrier
* */

import React, { useEffect, useMemo, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { CompanyType } from 'tennders-company/common/types/CompanyType'
import GLoading from 'tennders-market/common/components/element/GLoading'
import { GCheckBox, OnlyInputContainer, TextInput } from 'tennders-common/form/components'
import GHref from 'tennders-market/common/components/element/GHref'
import useMarketplace from 'tennders-market/load/hooks/useMarketplace'
import { apiPost } from 'tennders-stracture/libs/api'
import { useDispatch, useSelector } from 'react-redux'
import { StateType } from 'tennders-common/types/StateType'
import { dispatchSelectedRows } from 'tennders-common/stores/data/action'
import { useToast } from 'tennders-common/hooks/useToast'
import { dispatchMultiEditMode, dispatchMultiSelectMode } from 'tennders-common/stores/view/action'
import useSocket from 'tennders-common/hooks/useSocket'
import GModal from 'tennders-market/common/components/element/GModal'
import { dispatchShareLoadBox } from 'tennders-common/stores/modal/action'
import useShareLoad from 'tennders-market/common/hooks/useShareLoad'

const CARRIER_TAB = 1
const MP_TAB = 2

const MarketplaceTab = ({ companies, loading, form, onCompanyChange, onUserChange, t, isPublic, shareAsPublic, query }) => {
  const [filtereds, setFiltereds] = useState([])
  useEffect(() => {
    const carriers = [...companies]
    console.info('carriers', companies)
    if (query.length === 0) {
      setFiltereds(carriers)
      return
    }
    const f = []
    for (let i = 0; i < carriers.length; i += 1) {
      const filteredUsers = carriers[i]?.users?.filter((user) => user?.name?.toLowerCase().includes(query.toLowerCase()))
      if (carriers[i]?.name?.toLowerCase().includes(query.toLowerCase())) {
        f.push(carriers[i])
      } else if (filteredUsers?.length > 0) {
        f.push({ ...carriers[i], users: filteredUsers })
      }
    }
    setFiltereds(f)
  }, [query, companies])
  return (
    <div className="border-b mb-8">
      <div className="text-right">
        <GHref onClick={shareAsPublic} className="btn-border standard-btn mb-8 mt-16">
          {isPublic ? t('addLoad:share_with_selected') : t('addLoad:share_as_public')}
        </GHref>
      </div>
      <div className="tennders-carriers-share-list tennders-custom-scroll bg-color-white p-10 br-8 mb-8">
        {loading && <GLoading size={24} />}
        {!loading && filtereds.length === 0 && <p>{t('common:noResult')} </p>}
        {filtereds.map((company) => (
          <>
            <GCheckBox
              key={`company_${company.company_id}`}
              onChange={onCompanyChange}
              form={form}
              eClass="d-flex row align-center border-b mb-4 pb-4"
              name={`companies_${company.company_id}`}
              className="tennders-carriers-list-item form-checkbox"
            >
              <strong>{company.name}</strong>
            </GCheckBox>
            <div className="ml-24 mb-20">
              {
                company?.users?.map((user) => (
                  <GCheckBox
                    key={`carrier_${user.user_id}`}
                    onChange={onUserChange}
                    form={form}
                    eClass="d-flex row align-center border-b mb-4 pb-4"
                    name={`carriers_${user.user_id}`}
                    label={user.name}
                    className="tennders-carriers-list-item form-checkbox"
                  />
                ))
              }
            </div>
          </>
        ))}
      </div>

    </div>
  )
}

const BoxCarriersTab = ({ loading, carriers, onCompanyChange, onUserChange, form, t, selectAll, allSelected }) => (
  <div className="border-b mb-8">
    <div className="text-right">
      <GHref onClick={selectAll} className="btn-border standard-btn mb-8 mt-16">
        {allSelected ? t('common:unselect') : t('common:selectAll')}
      </GHref>
    </div>
    <div className="tennders-carriers-share-list tennders-custom-scroll bg-color-white p-10 br-8 mb-8">
      {loading && <GLoading size={24} />}
      {!loading && carriers.length === 0 && <p>{t('common:noResult')} </p>}
      {carriers.map((carrier) => (
        <>
          <GCheckBox
            key={`company_${carrier.id}`}
            onChange={onCompanyChange}
            form={form}
            eClass="d-flex row align-center border-b mb-4 pb-4"
            name={`companies_${carrier.id}`}
            className="tennders-carriers-list-item form-checkbox"
          >
            <strong>{carrier.name}</strong>
          </GCheckBox>
          <div className="ml-24 mb-20">
            {
              carrier?.users?.map((user) => (
                <GCheckBox
                  key={`carrier_${user.id}`}
                  onChange={onUserChange}
                  form={form}
                  eClass="d-flex row align-center border-b mb-4 pb-4"
                  name={`carriers_${user.id}`}
                  label={user.name}
                  className="tennders-carriers-list-item form-checkbox"
                />
              ))
            }
          </div>
        </>
      ))}
    </div>
  </div>
)

const ShareLoadBox = () => {
  const modalProps = useSelector((state:StateType) => state.modal.shareLoadBox)
  const dispatch = useDispatch()
  const {
    carriers,
    loading,
    query,
    setForm,
    onChange,
    filterBy,
    selectAll,
    withForm,
    allSelected,
    form,
    withoutMarketPlace,
    transactionId
  } = useShareLoad({
    modal: modalProps,
    onClose: () => dispatch(dispatchShareLoadBox(false))
  })
  const {
    singleTransaction,
    onSelectMp
  } = modalProps
  const [tab, setTab] = useState(CARRIER_TAB)
  const [localShared, setLocalShared] = useState({ })
  const [saving, setSaving] = useState(false)
  const { t } = useTranslation()
  const { marketplaceCompanies, mpCompaniesLoading, onMpUserChange, onMpCompanyChange, mpForm, shareAsPublic, isPublic, setMpForm } = useMarketplace({ transactionId, modalProps })
  const box_count = useMemo(() => Object.keys(form).filter((k) => k.includes('carriers') && form[k])?.length, [form])
  const mp_count = useMemo(() => Object.keys(mpForm).filter((k) => k.includes('carriers') && mpForm[k])?.length, [mpForm])
  const selectedRows = useSelector((state: StateType) => state.data.selectedRows)
  const setMultiSelectMode = (mode) => dispatch(dispatchMultiSelectMode(mode))
  const setEditMode = (mode) => dispatch(dispatchMultiEditMode(mode))
  const setSelectedRows = (rows) => dispatch(dispatchSelectedRows(rows))
  const { setRefresh } = useSocket()
  const { toastSuccess, toastError } = useToast()

  const onCompanyChange = (key, checked) => {
    const id = parseInt(key.replace(/companies_/, ''), 10)
    const f = { ...form }
    const localForm = { ...localShared }
    f[`companies_${id}`] = checked
    const company = carriers.filter((carrier) => carrier?.id === id)[0]
    company?.users?.forEach((user) => {
      f[`carriers_${user?.id}`] = checked
      localForm[`carriers_${user?.id}`] = checked
    })
    setForm(f)
    setLocalShared(localForm)
  }

  const onUserChange = (key, value) => {
    onChange(key, value)
    const localForm = { ...localShared }
    localForm[key] = value
    setLocalShared(localForm)
  }

  const changeTab = (t) => {
    if (tab !== t) {
      setTab(t)
    }
  }

  /*
  * gets the list of transactions ids from the rows selected in the load board
  * */
  const getTransactions = () => {
    const transactions = []
    for (let i = 0; i < Object.keys(selectedRows).length; i += 1) {
      const key = Object.keys(selectedRows)[i]
      if (key.includes('transaction_') && selectedRows[key] === true) {
        transactions.push(key.replace(/transaction_/, ''))
      }
    }
    return transactions
  }

  /*
  * Extracts the user and company list from object _form
  * @param _form: object to parse
  * */
  const getUsersAndCompanies = (_form) => {
    const companies = []
    const users = []
    for (let i = 0; i < Object.keys(_form).length; i += 1) {
      const key = Object.keys(_form)[i]
      if (key.includes('companies_') && _form[key] === true) {
        companies.push(key.replace(/companies_/, ''))
      }
      if (key.includes('carriers_') && _form[key] === true) {
        users.push(key.replace(/carriers_/, ''))
      }
    }
    return { companies, users }
  }

  const onClose = () => {
    setSelectedRows({})
    setForm({})
    setMpForm({})
    if (isPublic) {
      shareAsPublic()
    }
    filterBy('')
    setLocalShared({})
    setTab(CARRIER_TAB)
    dispatch(dispatchShareLoadBox(false))
  }

  /*
  * Shares the load with both marketplace and box carriers
  * @param marketplace: to share loads with marketplace
  * */
  const share = async () => {
    const { companies, users } = getUsersAndCompanies(form)
    const { companies: mpCompanies, users: mpUsers } = getUsersAndCompanies(mpForm)
    let error = ''
    let mp_error = ''
    const transactions = singleTransaction ? [transactionId] : getTransactions()
    setSaving(true)
    // if (mpCompanies?.length > 0 || mpUsers?.length > 0) {
    if (!withoutMarketPlace) {
      const mp_params = {
        transactions,
        companies: mpCompanies,
        users: mpUsers,
        marketPlace: true,
        ...(isPublic && { public: isPublic })
      }

      const res = await apiPost('broker/shareTransactions', mp_params)
      if (res.error) {
        mp_error = res.error
      }
    }
    const params = {
      transactions,
      companies,
      users
    }
    const response = await apiPost('broker/shareTransactions', params)
    if (response.error) {
      error = response.error
    }
    setSaving(false)
    if (error || mp_error) {
      if (mp_error) {
        toastError(mp_error)
      } if (error) {
        toastError(error)
      }
      return
    }
    toastSuccess('Updated successfully')
    setEditMode(false)
    setMultiSelectMode(false)
    setSelectedRows([])
    setRefresh('all')
    onClose()
  }

  useEffect(() => {
    if (onSelectMp) {
      onSelectMp({ ...getUsersAndCompanies(mpForm), ...(isPublic && { public: isPublic }) })
    }
  }, [mpForm, isPublic])

  return (
    <GModal
      size={600}
      close={onClose}
      isOpen={!!modalProps}
      extraClass="tennders-carriers-share-modal"
    >
      <div className="d-flex column justify-space w-100 mb-8">
        <div className="left d-flex row align-center mb-8">
          <div className="bold mr-8">{t('addLoad:share_load')}</div>
        </div>
        <div className="d-flex row justify-space align-center mb-8">
          <OnlyInputContainer
            name="name"
            form={form}
            inputValue={query}
            onChange={(k, v) => {
              onChange(k, v)
              filterBy(v)
            }}
            renderInput={(rest) => (
              <TextInput
                className="form-input smaller"
                placeholder={t('addLoad:search_by_name')}
                {...rest}
              />
            )}
          />
        </div>
        <div className="tennders-company-tabs">
          <ul className="tennders-tabs-titles">
            <li
              className={`${tab === CARRIER_TAB ? 'active' : 'inactive'}`}
              onClick={() => changeTab(CARRIER_TAB)}
            >
              <span className="d-flex align-center py-12">
                {t('addLoad:box_carriers')}
              </span>
            </li>
            {!withoutMarketPlace && (
              <li
                className={`${tab === MP_TAB ? 'active' : 'inactive'}`}
                onClick={() => changeTab(MP_TAB)}
              >
                <span className="d-flex align-center py-12">
                  {t('addLoad:marketplace')}
                </span>
              </li>
            )}
          </ul>
        </div>
        {tab === CARRIER_TAB && (
          <BoxCarriersTab
            t={t}
            form={form}
            onCompanyChange={onCompanyChange}
            onUserChange={onUserChange}
            carriers={carriers}
            loading={loading}
            allSelected={allSelected}
            selectAll={selectAll}
          />
        )}
        {tab === MP_TAB && !withoutMarketPlace && (
          <MarketplaceTab
            companies={marketplaceCompanies}
            t={t}
            query={query}
            loading={mpCompaniesLoading}
            onCompanyChange={onMpCompanyChange}
            onUserChange={onMpUserChange}
            form={mpForm}
            isPublic={isPublic}
            shareAsPublic={shareAsPublic}
          />
        )}
        <div className="mt-16 mb-8 text-center">
          {t('addLoad:from_box', { box_count })}
          {!withoutMarketPlace && t('addLoad:from_mp', { mp_count })}
        </div>
        <div className="text-right">
          <GHref onClick={onClose} className="btn-border standard-btn mr-8">
            {!withForm ? t('common:cancel') : t('common:close')}
          </GHref>
          {!withForm && (
            <GHref onClick={share} submitting={saving} className="btn standard-btn">
              {t('common:save')}
            </GHref>
          )}
        </div>
      </div>
    </GModal>
  )
}

export default ShareLoadBox
